import React from 'react';

const VARIANT_CLASSES = {
  compact: {
    container: 'flex items-center justify-center py-4',
    text: 'text-sm text-neutral-500',
  },
  full: {
    container: 'flex items-center justify-center h-full min-h-48',
    text: 'text-sm font-semibold text-neutral-500',
  },
} as const;

interface WidgetEmptyProps {
  'data-testid'?: string;
  message?: string;
  variant?: 'compact' | 'full';
}

const WidgetEmpty: React.FC<WidgetEmptyProps> = ({
  'data-testid': testId,
  message = 'No data available',
  variant = 'compact',
}) => {
  const classes = VARIANT_CLASSES[variant];

  return (
    <div className={classes.container} data-testid={testId}>
      <p className={classes.text}>{message}</p>
    </div>
  );
};

export default WidgetEmpty;
